<template lang="pug">
  .find-your-shade-cta.mt-100m
    a.find-your-shade-link.upper(v-if="!advisorCompleted" href="/color-advisor?rectype=color" @click.prevent="trackMREventAndRedirect('FindYourShadeCta - Find My Perfect Shade Clicked', '/color-advisor?rectype=color')")
      svg.xs-hide.md-hide(width="23" height="24" viewBox="0 0 23 24" xmlns="http://www.w3.org/2000/svg")
        circle(cx="11.5" cy="11.545" r="11.5" fill="#3D202A")
        path(d="M23 11.545C23 14.098 22.151 16.578 20.585 18.595 19.02 20.612 16.829 22.051 14.356 22.685 11.883 23.319 9.269 23.112 6.927 22.096 4.584 21.081 2.646 19.315 1.418 17.077 0.19 14.839-0.258 12.256 0.143 9.735 0.545 7.214 1.775 4.898 3.638 3.152 5.501 1.407 7.892 0.331 10.434 0.095 12.976-0.142 15.524 0.474 17.677 1.845L11.5 11.545H23Z" fill="#3F424D")
        path(d="M23 11.545C23 13.055 22.703 14.551 22.125 15.946 21.547 17.341 20.7 18.609 19.632 19.677L11.5 11.545H23Z" fill="#74100F")
        path(d="M19.632 19.677C18.055 21.254 16.053 22.338 13.871 22.798 11.689 23.258 9.42 23.073 7.341 22.267L11.5 11.545L19.632 19.677Z" fill="#522705")
        path(d="M7.391 22.286C5.308 21.489 3.502 20.104 2.192 18.299 0.882 16.494 0.126 14.347 0.014 12.12L11.5 11.545L7.391 22.286Z" fill="#DAB894")
        circle(cx="11.5" cy="11.545" r="5.75" fill="#FFF")
      span.semi-bold.xs-f-xsmall.md-f-small Find My Perfect Shade
      MrIcon.shade-icon(name="arrow-right" height="0.8em" :fill="true")
    ColorKitWhyMatchV2(v-else :match-type="matchType.key" :product="product")
</template>

<script>
  import { mapState } from 'vuex';
  import MrIcon from '@components/MrIcon/MrIcon';
  import ImgBox from '@components/imgBox';
  import ColorKitWhyMatchV2 from '../ColorKitWhyMatchV2';

  export default {
    name: "FindYourShadeCta",

    components: {
      MrIcon,
      ImgBox,
      ColorKitWhyMatchV2,
    },

    props: {
      product: {
        type: Object,
        default() {
          return {};
        }
      },
    },

    computed: {
      ...mapState('colorAdvisor', ['advisorCompleted']),

      colorMatches() {
        //- TODO refactor to not use $root for state management
        return this.$root.colorMatches;
      },

      matchType() {
        var type = {};
        var labelMap = {
          bestMatch: "Best Match",
          mostPopular: "Most Popular",
          customerMatch: "Your Pick",
          translatorMatch: "Translator Results",
          coloristMatch: "Colorist's Choice"
        };

        if (this.colorMatches && this.product) {
          Object.keys(this.colorMatches).forEach(key => {
            if (this.colorMatches[key] && this.colorMatches[key].code == this.product.code) {
              type.key = key;
              type.label = labelMap[key];
            }
          });
        }

        return type;
      },
    },

    methods: {
      
    }
  };
</script>

<style scoped lang="stylus">
  .find-your-shade-cta
    color brand-color-1
    width 100%

    .find-your-shade-link
      border-top 2px solid #7E727E33
      border-bottom 2px solid #7E727E33
      color brand-color-1
      letter-spacing 0.015rem
      padding 0.8em 0.5em 0.8em 0
      width 100%
      display flex
      justify-content space-between
      align-items center
      transition background-color 0.2s ease-in-out

      &:hover
        cursor pointer
        background-color #7E727E33

      &:active
        background-color #eaeaea

      @media mq-desktop-plus
        border 2px solid #7E727E33
        justify-content center
        gap 1em

      .shade-icon
        @media mq-desktop-plus
          margin-left 0.5em

      .palette-icon-wrap
        width 1.5em
        margin-left 1.9em
</style>
